function Page(element) {
  this.$element = $(element);

  this.selectors = {
    topBar: '.i4-topbar',
    scrollToElement: '.i4-scroll-to-element',
  };

  this.modifiers = {
    domLoaded: 'i4-page--domloaded',
    loaded: 'i4-page--loaded',
    adminPage: 'i4-template--administration',
    servicePage: 'i4-template--service-page',
    htmlI4: 'i4'
  };

  this.init = function () {
    // console.log('init - Page');

    this.addDomLoadedModifier();
    this.attachPageLoadEventListener();
    this.scrollToElement();
    this.addHtmlI4();
  };

  /**
   * add css class modifier on <body> to indicate DOM is fully loaded
   */
  this.addDomLoadedModifier = function () {
    // DOM is already ready and parsed when this is called
    this.$element.addClass(this.modifiers.domLoaded);
  };

  /**
   * attach an event listener that will add a css modifier on <body> once page fully loaded
   */
  this.attachPageLoadEventListener = function () {
    var me = this;
    // add .i4-page--loaded on full page load
    window.addEventListener('load', function (e) {
      // console.log('page and assets fully loaded');
      me.$element.addClass(me.modifiers.loaded);
    });

    // load event already passed!
    if (document.readyState === 'complete') {
      me.$element.addClass(me.modifiers.loaded);
    }
  };

  /**
   * scroll to element with a spcific css class (.i4-scroll-to-element)
   */
  this.scrollToElement = function () {
    const $scrollToElement = this.$element.find(this.selectors.scrollToElement);
    const $topBar = this.$element.find(this.selectors.topBar);
    const offset = 50;
    // console.log('$scrollToElement', $scrollToElement);

    if ($scrollToElement.length) {
      $('html, body').animate({
        scrollTop: ($scrollToElement.first().offset().top - $topBar.height() - offset)
      }, 400);
    }

  };

  this.addHtmlI4 = function () {
    if (this.$element.hasClass(this.modifiers.adminPage) || this.$element.hasClass(this.modifiers.servicePage)) {
      document.documentElement.className = this.modifiers.htmlI4;
    }
  };
}
